import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6459ecd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-cloud-arrow-up fa-3x mb-3" }, null, -1))
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "upload-text" }

import { ref } from "vue";
import { uploadFileOne, apiPost } from "@/api/index";
import { SAVE_FILE_ONE } from "@/api/const/file";
import { message } from 'ant-design-vue';

interface Props {
  documentClass: any,
  ocr: any,
  fileDraft: any,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadFileImages',
  props: {
    documentClass: { default: "INVOICE" },
    ocr: { default: "Y" },
    fileDraft: { default: "N" }
  },
  emits: ["uploadOneSuccess"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;
const fileList = ref<any[]>([]);
const imageUrl = ref("");

const props = __props
const beforeUpload = () => {
  // chặn auto upload của antd
  return false;
};

// const uploadFile = async (file: File) => {
//   if (!file) return;

//   // preview
//   imageUrl.value = URL.createObjectURL(file);

//   const formData = new FormData();
//   formData.append("documents", file);
//   formData.append("ocr", props.ocr);
//   formData.append("fileDraft", props.fileDraft);
//   formData.append("documentClass", props.documentClass);

//   try {
//     const response = await uploadFileOne(formData) || {};
//     let value = response.data?.data || "";
//     let url = value.fileUrl + value.folderPath + value.fileName || "";
//     let data = await saveFile(value);
//     if(data) {
//        emits("uploadOneSuccess", url);
//     }

//   } catch (e) {
//     console.error("upload error", e);
//   }
// };

const uploadFile = async (file: File) => {
  if (!file) return;

  // preview file mới
  imageUrl.value = URL.createObjectURL(file);

  const formData = new FormData();
  formData.append("documents", file);
  formData.append("ocr", props.ocr);
  formData.append("fileDraft", props.fileDraft);
  formData.append("documentClass", props.documentClass);

  try {
    const response = await uploadFileOne(formData);

    const value = response?.data?.data;

    if (!value) return;

    const url = `${value.fileUrl}${value.folderPath}${value.fileName}`;

    const data = await saveFile(value);

    if (data) {
      emits("uploadOneSuccess", url);

      // giữ lại đúng 1 file
      fileList.value = [
        {
          uid: file.uid || Date.now(),
          name: file.name,
          status: "done",
          url,
        },
      ];
    }
  } catch (e) {
    console.error("upload error", e);

    fileList.value = [];
  }
};

const saveFile = async (info: any) => {
  let data = await apiPost(SAVE_FILE_ONE, info);
  message.success('Tải lên file thành công');
  return data.data;
}

const handleChange = async (info: any) => {
  // chỉ lấy file mới nhất
  const latestFile = info.fileList.slice(-1);

  fileList.value = latestFile;

  // lấy file thật
  const file = latestFile?.[0]?.originFileObj;

  if (!file) return;

  // clear preview cũ tránh memory leak
  if (imageUrl.value) {
    URL.revokeObjectURL(imageUrl.value);
  }

  await uploadFile(file);
};

const handleRemove = () => {
  fileList.value = [];

  if (imageUrl.value) {
    URL.revokeObjectURL(imageUrl.value);
  }

  imageUrl.value = "";
};

return (_ctx: any,_cache: any) => {
  const _component_a_upload_dragger = _resolveComponent("a-upload-dragger")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_upload_dragger, {
      class: "file-uploader",
      "file-list": fileList.value,
      "show-upload-list": false,
      "before-upload": beforeUpload,
      onChange: handleChange,
      onRemove: handleRemove,
      "list-type": "picture",
      "max-count": 1
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_1,
          (imageUrl.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: imageUrl.value,
                class: "avatar"
              }, null, 8, _hoisted_2))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('upload.clickUpload')), 1)
        ])
      ]),
      _: 1
    }, 8, ["file-list"])
  ]))
}
}

})